import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  FunctionField,
  Filter,
  SearchInput,
  SelectInput,
} from 'react-admin';
import { Chip } from '@mui/material';
import ListPagination from '../../components/ListPagination';
import { Wrapper } from '../../components';
import Permission from '../../components/Permission';
import { PERMISSIONS, DATE_FORMATER } from '../../constants';
import RequiredChain from '../../components/RequiredChain';
import { CAMPAIGN_STATUS_CHOICES, campaignSituationLabel, campaignSituationColor } from './components/labels';

const RuleFilter: React.FC<any> = (props) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput
      source="status"
      label="Situação"
      choices={CAMPAIGN_STATUS_CHOICES}
      alwaysOn
    />
  </Filter>
);

const SituationField: React.FC = () => (
  <FunctionField
    label="Situação"
    render={(record: any) => (
      <Chip
        label={campaignSituationLabel(record)}
        color={campaignSituationColor(record) as any}
        size="small"
      />
    )}
  />
);

const CurrentLevelField: React.FC = () => (
  <FunctionField
    label="Nível atual"
    render={(record: any) => (record.currentLevelName ? `${record.currentLevelName} (${record.currentLevelOrder}/${record.levelsCount})` : '—')}
  />
);

const CustomerRecoveryRuleList: React.FC<any> = (props) => (
  <Permission permission={PERMISSIONS.CUSTOMER_RECOVERY_RULES}>
    <RequiredChain>
      <Wrapper>
        <List
          {...props}
          perPage={25}
          pagination={<ListPagination />}
          exporter={false}
          title="Campanhas de Recuperação"
          filters={<RuleFilter />}
          sort={{ field: 'createdAt', order: 'DESC' }}
        >
          <Datagrid bulkActionButtons={false} rowClick="show">
            <TextField source="name" label="Nome" />
            <SituationField />
            <CurrentLevelField />
            <DateField source="startedAt" label="Início" options={DATE_FORMATER} showTime emptyText="—" />
            <DateField source="endsAt" label="Fim previsto" options={DATE_FORMATER} showTime emptyText="—" />
            {/* Sem sortable: LIST_ORDERABLE_FIELDS (backend) não aceita esses 3 campos — o
                clique ordenava "às escondidas" caindo pra createdAt (achado da revisão adversarial). */}
            <NumberField source="audienceSize" label="Público" emptyText="0" sortable={false} />
            <NumberField source="recoveredCount" label="Recuperados" emptyText="0" sortable={false} />
            <NumberField source="broughtCount" label="Trazidos" emptyText="0" sortable={false} />
            <FunctionField
              label="Custo"
              render={(record: any) => `R$ ${Number(record.totalCost || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
            />
          </Datagrid>
        </List>
      </Wrapper>
    </RequiredChain>
  </Permission>
);

export default CustomerRecoveryRuleList;
